import axios from 'axios'
import auth from '../utils/auth'
import cfg from '../utils/config'

const configAuth = () => ({ headers: { Authorization: `Bearer ${auth.getToken()}` } })

const baseUrl = () => {
    const userInfo = auth.getUserInfo()
    return cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/confirmacao-email/'
}

const listarConfirmacoesEmail = async (params = {}) => {
    const response = await axios.get(baseUrl(), { ...configAuth(), params })
    return response.data
}

const enviarCodigoConfirmacaoEmail = async (email) => {
    const response = await axios.post(baseUrl() + 'enviar/', { email }, configAuth())
    return response.data
}

const confirmarCodigoEmail = async (email, codigo) => {
    const response = await axios.post(baseUrl() + 'confirmar/', { email, codigo }, configAuth())
    return response.data
}

const verificarEmailConfirmado = async (email) => {
    const response = await axios.get(baseUrl() + 'verificar/', { ...configAuth(), params: { email } })
    return response.data.confirmado
}

const removerConfirmacaoEmail = async (email) => {
    const response = await axios.post(baseUrl() + 'remover-confirmacao/', { email }, configAuth())
    return response.data
}

export { listarConfirmacoesEmail, enviarCodigoConfirmacaoEmail, confirmarCodigoEmail, verificarEmailConfirmado, removerConfirmacaoEmail }
